import { useEffect, useState, useMemo } from "react";
import React from 'react';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsExcel } from "../../utils/ExcelExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { openPdfResponse } from "../../utils/openPdfInApp";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import { default as ReactSelect } from "react-select";
import {getDispatchReport,getDispatchReportPDF} from "../../services/ReportServices";
import {  DatePicker } from 'antd';
import { getUserAllowedPlants} from '../../services/PlantServices';
import { getAllCustomerMain} from '../../services/CustomerMainServices';
import { getAllSalesRepresentatives } from '../../services/SalesRepresentativeServices';
import {getAllCustomerSites} from '../../services/CustomerSiteServices';
import { getAllProducts } from "../../services/ProductServices";
import { getAllEquipments } from '../../services/EquipmentServices';
import { getCustomerVehicles } from '../../services/DeliveryChallanServices';
import moment  from 'moment';
import {displayErrorToast,displayError,getApiErrorMessage,parseBoolean,parseBooleanToString} from '../../helpers';
import {HandleSelect,ValueContainer,Option,SearchableInput} from "../../components/MultiSelectControls";
import ReportExportDropdown from '../../components/ReportExportDropdown';
import ReportFilterToggleBar from '../../components/ReportFilterToggleBar';
import SettingsIcon from '../../components/SettingsIcon';
import { useReportTableExports } from '../../hooks/useReportTableExports';
import DispatchSummaryChart from '../../components/DispatchSummaryChart';
const {RangePicker} = DatePicker;

const dispatchFilterSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 10050 }),
    menu: (base) => ({ ...base, zIndex: 10050 }),
    menuList: (base) => ({ ...base, paddingTop: 4, paddingBottom: 4 }),
    option: (base, state) => ({
        ...base,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 8,
        color: "#1b2430",
        backgroundColor: state.isFocused ? "#e7f1ff" : "#ffffff",
        fontWeight: state.isSelected ? 600 : 400,
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
};

const dispatchFilterSelectProps = {
    menuPortalTarget: typeof document !== "undefined" ? document.body : null,
    menuPosition: "fixed",
    blurInputOnSelect: false,
    isSearchable: true,
    styles: dispatchFilterSelectStyles,
    components: { Option, ValueContainer, Input: SearchableInput },
};

const groupHeaderCellStyle = (row) => (
    row.is_group_header || row.is_total ? { fontWeight: 'bold', color: '#1e3a8a' } : undefined
);

const DISPATCH_REPORT_ALL_COLUMNS = [
    {
        fieldName: 'plant_alias',
        headerName: 'Plant',
        getCellStyle: groupHeaderCellStyle,
    },
    { fieldName: 'salesrep_alias', headerName: 'CSM', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'delivery_challan_no', headerName: 'DC No' },
    { fieldName: 'delivery_challan_date', headerName: 'Date', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'delivery_challan_time', headerName: 'Time' },
    { fieldName: 'customer_name', headerName: 'Customer', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'project_name', headerName: 'Site' },
    { fieldName: 'dc_grade', headerName: 'Grade' },
    { fieldName: 'dc_qty', headerName: 'Qty', align: 'right', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'rate', headerName: 'Rate', align: 'right' },
    { fieldName: 'amount', headerName: 'Amount', align: 'right', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'delivery_mode', headerName: 'Mode' },
    { fieldName: 'vehicle_no', headerName: 'Vehicle No' },
    { fieldName: 'pump', headerName: 'Pump No' },
    { fieldName: 'gang', headerName: 'Gang' },
    { fieldName: 'total_km', headerName: 'Total Km' },
    { fieldName: 'invoice_number', headerName: 'Invoice No.' },
];

/** Full column set for Report Type / Format "All" — matches dispatch report API fields. */
const DISPATCH_REPORT_FULL_COLUMNS = [
    { fieldName: 'plant_name', headerName: 'Plant Name', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'plant_alias', headerName: 'Plant', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'production_plant_name', headerName: 'Production Plant' },
    { fieldName: 'delivery_challan_date', headerName: 'Date', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'delivery_challan_no', headerName: 'DC No' },
    { fieldName: 'batch_no', headerName: 'Batch No' },
    { fieldName: 'delivery_challan_time', headerName: 'Time' },
    { fieldName: 'sales_order_no', headerName: 'SO No' },
    { fieldName: 'purchase_order_no', headerName: 'PO No' },
    { fieldName: 'invoice_number', headerName: 'Invoice No.' },
    { fieldName: 'customer_name', headerName: 'Customer', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'project_name', headerName: 'Site' },
    { fieldName: 'dc_grade', headerName: 'Grade' },
    { fieldName: 'dc_qty', headerName: 'Qty', align: 'right', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'rate', headerName: 'Rate', align: 'right' },
    { fieldName: 'amount', headerName: 'Amount', align: 'right', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'delivery_mode', headerName: 'Mode' },
    { fieldName: 'vehicle_no', headerName: 'Vehicle No' },
    { fieldName: 'salesrep_name', headerName: 'Marketing' },
    { fieldName: 'salesrep_alias', headerName: 'CSM', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'driver_name', headerName: 'Driver' },
    { fieldName: 'accepted_qty', headerName: 'Accepted Qty', align: 'right' },
    { fieldName: 'customer_dc_status', headerName: 'DC Status' },
    { fieldName: 'total_km', headerName: 'Total Km' },
    { fieldName: 'net_weight', headerName: 'Net Weight' },
    { fieldName: 'gang', headerName: 'Gang' },
    { fieldName: 'pump', headerName: 'Pump No' },
];

const formatTwoDecimals = (value) => {
    if (value === '' || value === null || value === undefined) {
        return '';
    }
    const num = Number(value);
    if (Number.isNaN(num)) {
        return '';
    }
    return num.toFixed(2);
};

const formatAbstractPlantHeader = (label = '') => (
    String(label).replace(/(\d{2})-(\d{2})/g, '$1\u2011$2')
);

const getAbstractPlantColumnWidth = (label = '') => Math.max(112, Math.min(240, label.length * 7));

const formatAbstractQtyDisplay = (value) => {
    const num = Number(value || 0);
    if (!num || num <= 0) {
        return '';
    }
    return num.toFixed(2);
};

const mapPlantwiseAbstractRow = (row, cols) => {
    const mapped = {
        id: row.id,
        delivery_challan_date: row.delivery_challan_date,
        total_qty: formatAbstractQtyDisplay(row.total_qty),
        is_total: !!row.is_total,
    };
    cols.forEach((col) => {
        mapped[col.field] = formatAbstractQtyDisplay(row[col.field]);
    });
    return mapped;
};

const orderPlantwiseAbstractRows = (rows) => {
    const totalRow = rows.find((row) => row.is_total);
    const detailRows = rows.filter((row) => !row.is_total);
    return totalRow ? [totalRow, ...detailRows] : detailRows;
};

const getCondensedRate = (qty, amount) => {
    const quantity = Number(qty || 0);
    if (!quantity) {
        return '';
    }
    return formatTwoDecimals(Number(amount || 0) / quantity);
};

const DISPATCH_CONDENSED_SITE_GRADE_MODE_QTY_AMOUNT = [
    { fieldName: 'project_name', headerName: 'Site' },
    { fieldName: 'dc_grade', headerName: 'Grade' },
    { fieldName: 'delivery_mode', headerName: 'Mode' },
    { fieldName: 'dc_qty', headerName: 'Qty', align: 'right', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'rate', headerName: 'Rate', align: 'right', getCellStyle: groupHeaderCellStyle },
    { fieldName: 'amount', headerName: 'Amount', align: 'right', getCellStyle: groupHeaderCellStyle },
];

const CONDENSED_GROUP_LEAD = {
    datewise: { field: 'delivery_challan_date', label: 'Date' },
    customerwise: { field: 'customer_name', label: 'Customer' },
    marketingwise: { field: 'salesrep_name', label: 'Marketing' },
};

const DISPATCH_SUMMARY_MODES = {
    plantwise: { field: 'plant_alias', label: 'Plant', headerName: 'Plant' },
    marketingwise: { field: 'salesrep_alias', label: 'Marketing', headerName: 'Marketing' },
    customerwise: { field: 'customer_name', label: 'Customer', headerName: 'Customer' },
    productwise: { field: 'dc_grade', label: 'Product', headerName: 'Product' },
};

const buildPeriodDateKeys = (fromDate, toDate) => {
    const keys = [];
    const cursor = fromDate.clone().startOf('day');
    const end = toDate.clone().startOf('day');
    while (cursor.isSameOrBefore(end, 'day')) {
        keys.push(cursor.format('DD-MM-YYYY'));
        cursor.add(1, 'day');
    }
    return keys;
};

const summaryDateField = (dateStr) => `d_${String(dateStr || '').replace(/-/g, '_')}`;

const formatSummaryQty = (value) => {
    if (!value) {
        return '';
    }
    return formatTwoDecimals(value);
};

/** Summary matrix: rows = plant/marketing/customer, columns = period dates, values = qty. */
const buildDispatchSummaryReport = (rows, fromDate, toDate, summaryMode) => {
    const modeConfig = DISPATCH_SUMMARY_MODES[summaryMode] || DISPATCH_SUMMARY_MODES.plantwise;
    const dateKeys = buildPeriodDateKeys(fromDate, toDate);
    const dateFields = dateKeys.map(summaryDateField);
    const entityMap = new Map();

    rows.forEach((row) => {
        const entity = row[modeConfig.field] || row.plant_name || row.salesrep_name || 'Unassigned';
        if (!entityMap.has(entity)) {
            const record = {
                id: `summary-${summaryMode}-${entity}`,
                entity_name: entity,
                total: 0,
            };
            dateFields.forEach((field) => {
                record[field] = 0;
            });
            entityMap.set(entity, record);
        }

        const record = entityMap.get(entity);
        const field = summaryDateField(row.delivery_challan_date);
        if (!Object.prototype.hasOwnProperty.call(record, field)) {
            return;
        }
        const increment = Number(row.dc_qty || 0);
        record[field] += increment;
        record.total += increment;
    });

    const entityRecords = Array.from(entityMap.values())
        .sort((left, right) => compareText(left.entity_name, right.entity_name));

    const totals = {
        id: 'summary-total',
        entity_name: 'Total',
        is_total: true,
        total: 0,
    };
    dateFields.forEach((field) => {
        totals[field] = 0;
    });
    entityRecords.forEach((record) => {
        dateFields.forEach((field) => {
            totals[field] += Number(record[field] || 0);
        });
        totals.total += Number(record.total || 0);
    });

    const records = [
        {
            ...totals,
            ...Object.fromEntries(
                dateFields.map((field) => [field, formatSummaryQty(totals[field])])
            ),
            total: formatSummaryQty(totals.total),
        },
        ...entityRecords.map((record) => {
            const next = { ...record };
            dateFields.forEach((field) => {
                next[field] = formatSummaryQty(record[field]);
            });
            next.total = formatSummaryQty(record.total);
            return next;
        }),
    ];

    const columns = [
        { fieldName: 'entity_name', headerName: modeConfig.headerName, minSize: 140 },
        ...dateKeys.map((dateKey) => ({
            fieldName: summaryDateField(dateKey),
            headerName: dateKey,
            align: 'right',
            minSize: 92,
            headerStyle: { whiteSpace: 'nowrap' },
        })),
        {
            fieldName: 'total',
            headerName: 'Total',
            align: 'right',
            minSize: 88,
            getCellStyle: () => ({ fontWeight: 700, color: '#0f255f' }),
        },
    ];

    const chartRows = entityRecords.map((record) => ({
        label: record.entity_name,
        total: Number(record.total || 0),
    }));

    return { columns, records, chartRows, modeLabel: modeConfig.label };
};

const compareText = (left, right) => String(left || '').localeCompare(
    String(right || ''),
    undefined,
    { sensitivity: 'base', numeric: true },
);

const parseDispatchDateValue = (row) => {
    if (row?.dc_date_original) {
        const parsed = moment(row.dc_date_original);
        if (parsed.isValid()) {
            return parsed.valueOf();
        }
    }
    const parsed = moment(row?.delivery_challan_date, 'DD-MM-YYYY', true);
    return parsed.isValid() ? parsed.valueOf() : 0;
};

const parseDispatchDateKey = (value) => {
    const parsed = moment(value, 'DD-MM-YYYY', true);
    return parsed.isValid() ? parsed.valueOf() : 0;
};

const compareDcNumber = (left, right) => {
    const leftText = String(left ?? '').trim();
    const rightText = String(right ?? '').trim();
    const leftNumeric = Number(leftText);
    const rightNumeric = Number(rightText);
    const leftIsNumeric = leftText !== '' && !Number.isNaN(leftNumeric);
    const rightIsNumeric = rightText !== '' && !Number.isNaN(rightNumeric);
    if (leftIsNumeric && rightIsNumeric) {
        return leftNumeric - rightNumeric;
    }
    return compareText(leftText, rightText);
};

const compareDispatchRows = (left, right) => {
    const dateDiff = parseDispatchDateValue(left) - parseDispatchDateValue(right);
    if (dateDiff !== 0) {
        return dateDiff;
    }
    const dcNoDiff = compareDcNumber(left.delivery_challan_no, right.delivery_challan_no);
    if (dcNoDiff !== 0) {
        return dcNoDiff;
    }
    const customerDiff = compareText(left.customer_name, right.customer_name);
    if (customerDiff !== 0) {
        return customerDiff;
    }
    const siteDiff = compareText(left.project_name, right.project_name);
    if (siteDiff !== 0) {
        return siteDiff;
    }
    const gradeDiff = compareText(left.dc_grade, right.dc_grade);
    if (gradeDiff !== 0) {
        return gradeDiff;
    }
    return compareText(left.delivery_mode, right.delivery_mode);
};

const sortDispatchRows = (rows) => [...rows].sort(compareDispatchRows);

const compareGroupKeys = (reportFormat, left, right) => {
    if (reportFormat === 'datewise') {
        return parseDispatchDateKey(left) - parseDispatchDateKey(right);
    }
    return compareText(left, right);
};

const getCondensedColumns = (reportFormat) => {
    const columns = [
        {
            fieldName: 'delivery_challan_date',
            headerName: 'Date',
            getCellStyle: groupHeaderCellStyle,
        },
        {
            fieldName: 'customer_name',
            headerName: 'Customer',
            getCellStyle: groupHeaderCellStyle,
        },
    ];

    if (reportFormat === 'marketingwise') {
        columns.push({
            fieldName: 'salesrep_name',
            headerName: 'Marketing',
            getCellStyle: groupHeaderCellStyle,
        });
    }

    columns.push(...DISPATCH_CONDENSED_SITE_GRADE_MODE_QTY_AMOUNT);
    return columns;
};

const aggregateCondensedDispatchRows = (rows) => {
    const groups = new Map();
    const orderedKeys = [];

    rows.forEach((row) => {
        const mode = (row.delivery_mode || '').toUpperCase();
        const key = [
            row.delivery_challan_date || '',
            row.customer_name || '',
            row.project_name || '',
            row.dc_grade || '',
            mode,
        ].join('|||');

        if (!groups.has(key)) {
            groups.set(key, {
                id: `condensed-${orderedKeys.length}`,
                delivery_challan_date: row.delivery_challan_date,
                dc_date_original: row.dc_date_original,
                customer_name: row.customer_name,
                customer_id: row.customer_id,
                project_name: row.project_name,
                dc_grade: row.dc_grade,
                delivery_mode: mode,
                salesrep_id: row.salesrep_id,
                salesrep_name: row.salesrep_name,
                dc_qty: 0,
                amount: 0,
            });
            orderedKeys.push(key);
        }

        const agg = groups.get(key);
        agg.dc_qty += Number(row.dc_qty || 0);
        agg.amount += Number(row.amount || 0);
    });

    return orderedKeys.map((key) => {
        const row = groups.get(key);
        const dcQty = Number(row.dc_qty.toFixed(2));
        const amount = Number(row.amount.toFixed(2));
        return {
            ...row,
            dc_qty: formatTwoDecimals(dcQty),
            amount: formatTwoDecimals(amount),
            rate: getCondensedRate(dcQty, amount),
        };
    });
};

function DispatchReportTable() 
{
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(false); 
    const [plants, setPlants] = React.useState([]);
    const [selectedPlant, setSelectedPlant] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [selectedSalesrep, setSelectedSalesRep] = useState([]);
    const [salesreps, setSalesreps] = useState([]);
    const [selectedSite, setSelectedSite] = useState([]);
    const [sites, setSites] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState([]);
    const [grades, setGrades] = useState([]);
    const [inputs, setInputs] = useState({ report_format: 'datewise' });
    const [reportSettings, setReportSettings] = useState({ report_type: 'detailed' });
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [settingsDraft, setSettingsDraft] = useState({
        report_type: 'detailed',
        selectedPlant: [],
        selectedSalesrep: [],
        selectedVehicle: [],
    });
    const [totalDcQty, setTotalDcQty] = useState('0.00');
    const [cancelledDcQty, setCancelledDcQty] = useState('0.00');
    const [cancelledDetailRows, setCancelledDetailRows] = useState([]);
    const [showCancelledDetails, setShowCancelledDetails] = useState(false);
    const [totalAmount, setTotalAmount] = useState('0.00');
    const [plantColumns, setPlantColumns] = useState([]);
    const [summaryColumns, setSummaryColumns] = useState([]);
    const [summaryChartRows, setSummaryChartRows] = useState([]);
    const [summaryModeLabel, setSummaryModeLabel] = useState('Plant');
    const [displayReportFormat, setDisplayReportFormat] = useState('datewise');
    const isSummaryReport = reportSettings.report_type === 'summary';
    const isPlantwiseAbstract = !isSummaryReport && inputs.report_format === 'plantwise_abstract';
    const [filtersVisible, setFiltersVisible] = useState(true);

    // Initial state for from_date and to_date
    const initialFromDate = moment().startOf('month');
    const initialToDate =  moment();
    const [fromDate, setFromDate] = useState(initialFromDate);
    const [toDate, setToDate] = useState(initialToDate);
    const handleDateChange = (values) => {
        if ((values) && (values.length === 2)) {
        setFromDate(values[0]);
        setToDate(values[1]);
        }
    };

    React.useEffect(() => {
        getUserAllowedPlants(cookies)
        .then (
            plantList => {
                const plantOptions = plantList.plant_list.map(
                    plant => ({ value: plant.id, label: plant.plant_alias })
                );
                setPlants(plantOptions);
                setSelectedPlant([
                    { value: 'select-all', label: 'Select All plants' },
                ]);
            }
        )
    }, []);

    React.useEffect(() => {
        getAllCustomerMain(cookies)
        .then (
            customerList => {
                const customers = customerList.customer_list.map(
                    customer => {
                        return { value: customer.id, label: customer.name }
                    }
                );
                setCustomers(customers);
                setSelectedCustomer([{ value: 'select-all', label: 'Select All customers' }]);
            }
        )
    }, []);

    React.useEffect(() => {
    getAllCustomerSites(cookies)
    .then (
        siteList => {
            const sites = siteList.consignee_list.map(
                site => {
                    return { value: site.id, label: site.name }
                }
            );
            setSites(sites);
            setSelectedSite([{ value: 'select-all', label: 'Select All sites' }]);
        }
    )
    }, []);

    React.useEffect(() => {
        getAllSalesRepresentatives(cookies)
        .then (
            salesRepList => {
                const salesrep = salesRepList.salesrep_data.map(
                sales => {
                        return { value: sales.id, label: sales.entity_name }
                    }
                );
                //console.log(JSON.stringify(salesRepList)+"salesRepList")
                setSalesreps(salesrep);
                setSelectedSalesRep([{ value: 'select-all', label: 'Select All sales representatives' }]);
            }
        )
    }, []);

    React.useEffect(() => {
        let cancelled = false;
        Promise.all([
            getCustomerVehicles(cookies).catch(() => ({ customer_vehicles_list: [] })),
            getAllEquipments(cookies).catch(() => ({ equipment_list: [] })),
        ]).then(([customerEquip, equipmentObject]) => {
            if (cancelled) {
                return;
            }
            const customerVehicles = (customerEquip.customer_vehicles_list || []).map((equip) => ({
                value: equip,
                label: equip,
            }));
            const ownVehicles = (equipmentObject.equipment_list || [])
                .filter((obj) => {
                    const typeName = String(obj?.equip_type?.name || obj?.equip_type || '').toUpperCase();
                    return obj?.status && typeName === 'TRANSIT MIXER';
                })
                .map((equipment) => ({
                    value: equipment.id,
                    label: equipment.equip_name,
                }));
            const merged = [...customerVehicles, ...ownVehicles];
            setVehicles(merged);
            setSelectedVehicle([{ value: 'select-all', label: 'Select All vehicles' }]);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    React.useEffect(() => {
        getAllProducts(cookies)
        .then (
            productList => {
                const products = productList.product_list.map(
                    product => {
                        return { value: product.id, label: product.name}
                    }
                )
                setGrades(products);
                setSelectedGrade([{ value: 'select-all', label: 'Select All grades' }]);
            }
        )
    }, []);

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
        if (name === 'report_format') {
            setData(InitialData);
            setPlantColumns([]);
            setTotalDcQty('0.00');
            setTotalAmount('0.00');
        }
    }

    // Add a "Select All" option to the plants array
    const plantsWithSelectAll = useMemo(() => ([
        { value: "select-all", label: "Select All plants" },
        ...plants,
    ]), [plants]);

    // Add a "Select All" option to the customers array
    const customersWithSelectAll = [
        { value: "select-all", label: "Select All customers" },
        ...customers,
    ];
    
    // Add a "Select All" option to the sites array
    const sitesWithSelectAll = [
        { value: "select-all", label: "Select All sites" },
        ...sites,
    ];
    
    // Add a "Select All" option to the salesreps array
    const salesrepsWithSelectAll = useMemo(() => ([
        { value: "select-all", label: "Select All sales representatives" },
        ...salesreps,
    ]), [salesreps]);
    
    // Add a "Select All" option to the vehicles array
    const vehiclesWithSelectAll = useMemo(() => ([
        { value: "select-all", label: "Select All vehicles" },
        ...vehicles,
    ]), [vehicles]);

    // Add a "Select All" option to the grades array
    const gradesWithSelectAll = [
        { value: "select-all", label: "Select All grades" },
        ...grades,
    ];
      
    const onCustomerSelect = (selected) => {
        HandleSelect(selected,selectedCustomer, setSelectedCustomer, customers, customersWithSelectAll);
    };
    
    const onSiteSelect = (selected) => {
        HandleSelect(selected,selectedSite, setSelectedSite, sites, sitesWithSelectAll);
    };
    
    const onGradeSelect = (selected) => {
        HandleSelect(selected,selectedGrade, setSelectedGrade, grades, gradesWithSelectAll);
    };

    const areAllPlantsSelected = () => {
        const realPlants = plants.filter((plant) => plant.value !== 'select-all');
        if (!realPlants.length) {
            return false;
        }
        if ((selectedPlant || []).some((plant) => plant.value === 'select-all')) {
            return true;
        }
        return realPlants.every((plant) =>
            selectedPlant.some((selected) => selected.value === plant.value),
        );
    };

    const getSelectedPlantsForReport = () => {
        const realPlants = plants.filter((plant) => plant.value !== 'select-all');
        if (areAllPlantsSelected()) {
            return realPlants;
        }
        return selectedPlant.filter((plant) => plant.value !== 'select-all');
    };

    const selectedAbstractPlantColumns = useMemo(() => {
        if (!isPlantwiseAbstract) {
            return [];
        }
        return getSelectedPlantsForReport()
            .map((plant) => ({
                plant_id: plant.value,
                label: plant.label,
                field: `plant_${plant.value}`,
            }))
            .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPlantwiseAbstract, selectedPlant, plants]);

    const isSelectAllActive = (selected) => (
        Array.isArray(selected) && selected.some((item) => item.value === 'select-all')
    );

    const areAllOptionsSelected = (options, selected) => {
        if (!options?.length) {
            return false;
        }
        if (isSelectAllActive(selected)) {
            return true;
        }
        if (!selected?.length) {
            return false;
        }
        return options.every((option) =>
            selected.some((item) => String(item.value) === String(option.value))
        );
    };

    const joinSelectedIds = (selected, allSelected) => {
        const chosen = (selected || []).filter((item) => item && item.value !== 'select-all');
        if (allSelected || chosen.length === 0) {
            return '*';
        }
        return chosen.map((item) => item.value).join(',');
    };

    const areAllCustomersSelected = () => areAllOptionsSelected(customers, selectedCustomer);
    const areAllConsigneesSelected = () => areAllOptionsSelected(sites, selectedSite);
    const areAllSalesRepsSelected = () => areAllOptionsSelected(salesreps, selectedSalesrep);
    const areAllVehiclesSelected = () => areAllOptionsSelected(vehicles, selectedVehicle);
    const areAllGradesSelected = () => areAllOptionsSelected(grades, selectedGrade);

    const hasSelectedPlants = () => (
        areAllPlantsSelected()
        || selectedPlant.some((plant) => plant.value !== 'select-all')
    );

    const hasSelectedSalesReps = () => (
        areAllSalesRepsSelected()
        || selectedSalesrep.some((salesrep) => salesrep.value !== 'select-all')
    );

    const hasSelectedVehicles = () => (
        areAllVehiclesSelected()
        || selectedVehicle.some((vehicle) => vehicle.value !== 'select-all')
    );

    const openReportSettings = () => {
        setSettingsDraft({
            report_type: reportSettings.report_type,
            selectedPlant: selectedPlant?.length
                ? selectedPlant
                : [{ value: 'select-all', label: 'Select All plants' }],
            selectedSalesrep: selectedSalesrep?.length
                ? selectedSalesrep
                : [{ value: 'select-all', label: 'Select All sales representatives' }],
            selectedVehicle: selectedVehicle?.length
                ? selectedVehicle
                : [{ value: 'select-all', label: 'Select All vehicles' }],
        });
        setShowSettingsModal(true);
    };

    const applyReportSettings = () => {
        const draftPlants = settingsDraft.selectedPlant || [];
        const draftSalesreps = settingsDraft.selectedSalesrep || [];
        const draftVehicles = settingsDraft.selectedVehicle || [];
        const hasPlants = draftPlants.some((plant) => plant.value === 'select-all')
            || draftPlants.some((plant) => plant.value !== 'select-all');
        const hasSalesreps = draftSalesreps.some((salesrep) => salesrep.value === 'select-all')
            || draftSalesreps.some((salesrep) => salesrep.value !== 'select-all');
        const hasVehicles = draftVehicles.some((vehicle) => vehicle.value === 'select-all')
            || draftVehicles.some((vehicle) => vehicle.value !== 'select-all');
        if (!hasPlants) {
            Swal.fire('Please select at least one plant in report settings.', '', 'info');
            return;
        }
        if (!hasSalesreps) {
            Swal.fire('Please select at least one sales rep in report settings.', '', 'info');
            return;
        }
        if (!hasVehicles) {
            Swal.fire('Please select at least one vehicle in report settings.', '', 'info');
            return;
        }
        if (!vehicles.length) {
            Swal.fire('No vehicles are available to select. Please refresh and try again.', '', 'info');
            return;
        }
        setReportSettings({ report_type: settingsDraft.report_type });
        setSelectedPlant(
            draftPlants.some((plant) => plant.value === 'select-all')
                ? [{ value: 'select-all', label: 'Select All plants' }]
                : draftPlants
        );
        setSelectedSalesRep(
            draftSalesreps.some((salesrep) => salesrep.value === 'select-all')
                ? [{ value: 'select-all', label: 'Select All sales representatives' }]
                : draftSalesreps
        );
        setSelectedVehicle(
            draftVehicles.some((vehicle) => vehicle.value === 'select-all')
                ? [{ value: 'select-all', label: 'Select All vehicles' }]
                : draftVehicles
        );
        if (settingsDraft.report_type === 'summary') {
            setInputs((current) => ({
                ...current,
                report_format: DISPATCH_SUMMARY_MODES[current.report_format]
                    ? current.report_format
                    : 'plantwise',
            }));
            setData({ records: [] });
            setSummaryColumns([]);
            setSummaryChartRows([]);
        } else if (DISPATCH_SUMMARY_MODES[inputs.report_format]) {
            setInputs((current) => ({ ...current, report_format: 'datewise' }));
            setSummaryColumns([]);
            setSummaryChartRows([]);
        }
        setShowSettingsModal(false);
    };

    const onSettingsPlantSelect = (selected) => {
        HandleSelect(selected, settingsDraft.selectedPlant, (value) => {
            setSettingsDraft((current) => ({ ...current, selectedPlant: value }));
        }, plants, plantsWithSelectAll);
    };

    const onSettingsSalesRepSelect = (selected) => {
        HandleSelect(selected, settingsDraft.selectedSalesrep, (value) => {
            setSettingsDraft((current) => ({ ...current, selectedSalesrep: value }));
        }, salesreps, salesrepsWithSelectAll);
    };

    const onSettingsVehicleSelect = (selected) => {
        HandleSelect(selected, settingsDraft.selectedVehicle, (value) => {
            setSettingsDraft((current) => ({ ...current, selectedVehicle: value }));
        }, vehicles, vehiclesWithSelectAll);
    };

    const mapDispatchReportRow = (dc) => ({
        plant_name: dc.plant_name || '',
        plant_alias: dc.plant_alias || dc.plant_name || '',
        production_plant_name: dc.production_plant_name || '',
        id: dc.id,
        customer_id: dc.customer_id,
        salesrep_id: dc.salesrep_id,
        batch_no: dc.batch_no || '',
        delivery_challan_no: dc.delivery_challan_no || '',
        delivery_challan_date: dc.delivery_challan_date || '',
        dc_date_original: dc.dc_date_original,
        delivery_challan_time: dc.delivery_challan_time || '',
        sales_order_no: dc.sales_order_no || '',
        purchase_order_no: dc.purchase_order_no || '',
        invoice_number: dc.invoice_number || '',
        customer_name: dc.customer_name || '',
        project_name: dc.project_name || '',
        dc_grade: dc.dc_grade || '',
        dc_qty: formatTwoDecimals(dc.dc_qty),
        rate: formatTwoDecimals(dc.rate),
        amount: formatTwoDecimals(dc.amount),
        delivery_mode: (dc.delivery_mode || '').toUpperCase(),
        vehicle_no: dc.vehicle_no || '',
        salesrep_name: dc.salesrep_name || '',
        salesrep_alias: dc.salesrep_alias || dc.salesrep_name || '',
        driver_name: dc.driver_name || '',
        accepted_qty: formatTwoDecimals(dc.accepted_qty),
        customer_dc_status: dc.customer_dc_status || '',
        total_km: dc.total_km ?? '',
        net_weight: dc.net_weight ?? '',
        gang: dc.gang || '',
        pump: dc.pump || '',
        is_cancelled: Boolean(dc.is_cancelled),
    });

    const buildGroupedReportRows = (rows, reportFormat) => {
        if (['all', 'plantwise_abstract'].includes(reportFormat) || !rows.length) {
            return rows;
        }

        const groupConfig = CONDENSED_GROUP_LEAD;
        const config = groupConfig[reportFormat];
        if (!config) {
            return rows;
        }

        const orderedKeys = [];
        const groups = new Map();

        rows.forEach((row) => {
            const key = row[config.field] || 'Unassigned';
            if (!groups.has(key)) {
                groups.set(key, []);
                orderedKeys.push(key);
            }
            groups.get(key).push(row);
        });

        const groupedRows = [];
        orderedKeys.sort((left, right) => compareGroupKeys(reportFormat, left, right));
        orderedKeys.forEach((key) => {
            const groupRows = sortDispatchRows(groups.get(key) || []);
            const groupQty = groupRows.reduce((sum, row) => sum + Number(row.dc_qty || 0), 0);
            const groupAmount = groupRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);
            const headerRow = {
                id: `group-${config.label}-${key}`,
                is_group_header: true,
                dc_qty: groupQty.toFixed(2),
                amount: groupAmount.toFixed(2),
                rate: getCondensedRate(groupQty, groupAmount),
            };
            // Always show group title in the first visible column.
            const useFullColumns = reportSettings.report_type === 'all' || reportFormat === 'all';
            const groupLabelField = reportSettings.report_type === 'condensed'
                ? 'delivery_challan_date'
                : (useFullColumns ? 'plant_name' : 'plant_alias');
            headerRow[groupLabelField] = key;
            groupedRows.push(headerRow);
            groupedRows.push(...groupRows);
        });
        return groupedRows;
    };

    const Home = () => {
        navigate('/Home')
    }

    const detailColumns = useMemo(() => {
        if (isSummaryReport) {
            return summaryColumns.length
                ? summaryColumns
                : [{ fieldName: 'entity_name', headerName: 'Name' }];
        }
        if (reportSettings.report_type === 'condensed') {
            return getCondensedColumns(displayReportFormat);
        }
        if (reportSettings.report_type === 'all' || displayReportFormat === 'all') {
            return DISPATCH_REPORT_FULL_COLUMNS;
        }
        return DISPATCH_REPORT_ALL_COLUMNS;
    }, [reportSettings.report_type, displayReportFormat, isSummaryReport, summaryColumns]);

    const abstractColumns = useMemo(
        () => [
            {
                fieldName: 'delivery_challan_date',
                headerName: 'Date',
                getCellStyle: groupHeaderCellStyle,
                minSize: 92,
                headerStyle: { whiteSpace: 'nowrap' },
            },
            ...(selectedAbstractPlantColumns.length ? selectedAbstractPlantColumns : plantColumns).map((col) => ({
                fieldName: col.field,
                headerName: formatAbstractPlantHeader(col.label),
                align: 'right',
                getCellStyle: groupHeaderCellStyle,
                minSize: getAbstractPlantColumnWidth(col.label),
                headerStyle: { whiteSpace: 'nowrap' },
            })),
            {
                fieldName: 'total_qty',
                headerName: 'Total',
                align: 'right',
                getCellStyle: groupHeaderCellStyle,
                minSize: 88,
                headerStyle: { whiteSpace: 'nowrap' },
            },
        ],
        [selectedAbstractPlantColumns, plantColumns],
    );

    const columns = showCancelledDetails
        ? DISPATCH_REPORT_ALL_COLUMNS
        : (isPlantwiseAbstract ? abstractColumns : detailColumns);

    const { onImage: handleImageExport } = useReportTableExports({
        columns,
        records: data.records,
        title: isPlantwiseAbstract ? 'Dispatch Report - Plantwise Abstract' : 'Dispatch Report',
        filename: 'dispatch_report',
    });
   
    const handleCSVExport = (event) => {
        if (isPlantwiseAbstract) {
            exportAsCSV(columns, data.records);
            return;
        }
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(dc => {
                const csvRow = {
                    plant_name:dc.plant_name,
                    plant_alias: dc.plant_alias,
                    production_plant_name: dc.production_plant_name,
                    delivery_challan_date: dc.delivery_challan_date,
                    delivery_challan_no: dc.delivery_challan_no,
                    batch_no: dc.batch_no,
                    delivery_challan_time: dc.delivery_challan_time,
                    sales_order_no: dc.sales_order_no,
                    purchase_order_no:dc.purchase_order_no,
                    invoice_number: dc.invoice_number,
                    customer_name:dc.customer_name,
                    project_name:dc.project_name,
                    dc_grade:  dc.dc_grade,
                    dc_qty: dc.dc_qty,
                    rate: dc.rate,
                    amount:dc.amount,
                    delivery_mode: dc.delivery_mode.toUpperCase(),
                    vehicle_no: dc.vehicle_no,
                    salesrep_name: dc.salesrep_name,
                    driver_name:  dc.driver_name,
                    accepted_qty:  dc.accepted_qty,
                    customer_dc_status: dc.customer_dc_status,
                    total_km:  dc.total_km,
                    net_weight:  dc.net_weight,
                    gang:dc.gang,
                    pump:dc.pump
                }
                return csvRow;
                }))
    };

    const handlePDFExport = (event) => {
        // console.log('PDF Export');
        exportAsPDF(
            'Dispatch Report',
            columns
            .filter(col => ['Date', 'DC Number','Time','Customer Name','Site/Project Name','DC Grade','DC Qty','Rate','Amount','Vehicle No','Marketting'].includes(col.headerName))
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(dc => ({
                delivery_challan_no: dc.delivery_challan_no,
                delivery_challan_date: dc.delivery_challan_date,
                delivery_challan_time: dc.delivery_challan_time,
                customer_name:dc.customer_name,
                project_name:dc.project_name,
                salesrep_name: dc.salesrep_name,
                vehicle_no: dc.vehicle_no,
                dc_grade:  dc.dc_grade,
                dc_qty: dc.dc_qty,
                rate: dc.rate,
                amount:  dc.amount
            })),
            'Dispatch_report.pdf'
        );
    };

    const constructFormData = () => {
        const selectedPlants = getSelectedPlantsForReport();
        const plantIds = isPlantwiseAbstract
            ? selectedPlants.map((plant) => plant.value).join(',')
            : (areAllPlantsSelected()
                ? '*'
                : selectedPlants.map((plant) => plant.value).join(','));
        const apiReportFormat = isSummaryReport ? 'all' : inputs.report_format;
        const apiReportType = isSummaryReport
            ? 'detailed'
            : (reportSettings.report_type === 'summary' ? 'detailed' : (reportSettings.report_type || 'detailed'));
        return {
            plant_ids: plantIds,
            customer_ids: joinSelectedIds(selectedCustomer, areAllCustomersSelected()),
            consignee_ids: joinSelectedIds(selectedSite, areAllConsigneesSelected()),
            sales_rep_ids: joinSelectedIds(selectedSalesrep, areAllSalesRepsSelected()),
            vehicle_ids: joinSelectedIds(selectedVehicle, areAllVehiclesSelected()),
            product_ids: joinSelectedIds(selectedGrade, areAllGradesSelected()),
            from_date:fromDate.format('DD-MM-YYYY'),
            upto_date:toDate.format('DD-MM-YYYY'),
            report_format: apiReportFormat,
            report_type: apiReportType === 'all' ? 'all' : apiReportType,
          }
    }

    const storeCancelledDetails = (rows) => {
        const cancelled = (rows || []).filter((row) => row.is_cancelled);
        const qty = cancelled.reduce((sum, row) => sum + Number(row.dc_qty || 0), 0);
        setCancelledDetailRows(cancelled);
        setCancelledDcQty(qty.toFixed(2));
        setShowCancelledDetails(false);
    };

    const handleGenerate = () => {
        const formData = constructFormData();
        if (!hasSelectedPlants()) {
            Swal.fire('Please select at least one plant in report settings.', '', 'info');
            return;
        }
        if (!hasSelectedSalesReps()) {
            Swal.fire('Please select at least one sales rep in report settings.', '', 'info');
            return;
        }
        if (!hasSelectedVehicles()) {
            Swal.fire('Please select at least one vehicle in report settings.', '', 'info');
            return;
        }
        if (isSummaryReport && !DISPATCH_SUMMARY_MODES[inputs.report_format]) {
            Swal.fire('Please select Plantwise, Marketingwise, Customerwise or Productwise for Summary.', '', 'info');
            return;
        }
        if (!formData.from_date || !formData.upto_date || !formData.report_format) {
            Swal.fire('Please choose the date range and report format.', '', 'info');
            return;
        }
        {
            setIsLoading(true);
            getDispatchReport(cookies, formData)
            .then(response => {
                if (isSummaryReport) {
                    const mappedRows = (response.dispatch_report_list || []).map(mapDispatchReportRow);
                    const detailRows = mappedRows.filter((row) => !row.is_cancelled);
                    storeCancelledDetails(mappedRows);
                    const summary = buildDispatchSummaryReport(
                        detailRows,
                        fromDate,
                        toDate,
                        inputs.report_format,
                    );
                    setPlantColumns([]);
                    setSummaryColumns(summary.columns);
                    setSummaryChartRows(summary.chartRows);
                    setSummaryModeLabel(summary.modeLabel);
                    setData({ records: summary.records });
                    setDisplayReportFormat(inputs.report_format);
                    setTotalDcQty(Number(response.total_dc_qty || 0).toFixed(2));
                    setTotalAmount('0.00');
                    setFiltersVisible(false);
                    setIsLoading(false);
                    return;
                }
                setSummaryColumns([]);
                setSummaryChartRows([]);
                if (formData.report_format === 'plantwise_abstract') {
                    storeCancelledDetails((response.cancelled_dispatch_list || []).map(mapDispatchReportRow));
                    const cols = selectedAbstractPlantColumns.length
                        ? selectedAbstractPlantColumns
                        : (response.plant_columns || []);
                    setPlantColumns(cols);
                    const tableData = orderPlantwiseAbstractRows(
                        (response.dispatch_report_list || []).map((row) => (
                            mapPlantwiseAbstractRow(row, cols)
                        )),
                    );
                    setData({ records: tableData });
                    setDisplayReportFormat(formData.report_format);
                    setTotalDcQty(Number(response.total_dc_qty || 0).toFixed(2));
                    setTotalAmount('0.00');
                    setFiltersVisible(false);
                    setIsLoading(false);
                    return;
                }
                setPlantColumns([]);
                const mappedRows = sortDispatchRows(
                    (response.dispatch_report_list || []).map(mapDispatchReportRow),
                );
                storeCancelledDetails(mappedRows);
                let detailRows = mappedRows.filter((row) => !row.is_cancelled);
                if (formData.report_type === 'condensed') {
                    detailRows = sortDispatchRows(aggregateCondensedDispatchRows(detailRows));
                }
                const tableData = buildGroupedReportRows(detailRows, formData.report_format);
                setData({ records: tableData });
                setDisplayReportFormat(formData.report_format);
                const qtyTotal = Number(response.total_dc_qty || 0);
                const amountTotal = detailRows.reduce((sum, row) => sum + Number(row.amount || 0), 0);
                setTotalDcQty(qtyTotal.toFixed(2));
                setTotalAmount(amountTotal.toFixed(2));
                setFiltersVisible(false);
                setIsLoading(false);
            }).catch((error) => {
                displayError(error.response?.data || getApiErrorMessage(error));
                setIsLoading(false);
            });
        }
    };

    const handleSubmit=(event)=>
    {
        event.preventDefault();
        handleGenerate();
    }

        const handleDownloadPdf = () => {
            console.log(JSON.stringify(constructFormData())+"submit")
            const inputs = constructFormData();
            if (!hasSelectedPlants()) {
                Swal.fire('Please select at least one plant in report settings.', '', 'info');
                return;
            }
            if (!hasSelectedSalesReps()) {
                Swal.fire('Please select at least one sales rep in report settings.', '', 'info');
                return;
            }
            if (!hasSelectedVehicles()) {
                Swal.fire('Please select at least one vehicle in report settings.', '', 'info');
                return;
            }
            if (!inputs.from_date || !inputs.upto_date || !inputs.report_format) {
                Swal.fire('Please choose the date range and report format.', '', 'info');
                return;
            }
            {
                getDispatchReportPDF(cookies, constructFormData())
                .then(response => {
                    openPdfResponse(response, {
                        title: 'Dispatch Report',
                        downloadFileName: 'Dispatch_report.pdf',
                    });
                    setIsLoading(false);
                })
                .catch((error) => {
                    displayError(error.response?.data || getApiErrorMessage(error));
                });
            }
        };

        const handleDownloadExcel = () => {
            const formData = constructFormData();
            if (!hasSelectedPlants()) {
                Swal.fire('Please select at least one plant in report settings.', '', 'info');
                return;
            }
            if (!hasSelectedSalesReps()) {
                Swal.fire('Please select at least one sales rep in report settings.', '', 'info');
                return;
            }
            if (!hasSelectedVehicles()) {
                Swal.fire('Please select at least one vehicle in report settings.', '', 'info');
                return;
            }
            if (!formData.from_date || !formData.upto_date || !formData.report_format) {
                Swal.fire('Please choose the date range and report format.', '', 'info');
                return;
            }
            {
                setIsLoading(true);
                getDispatchReport(cookies, formData)
                .then((response) => {
                    let exportColumns;
                    let exportRecords = [];

                    if (formData.report_format === 'plantwise_abstract') {
                        const cols = selectedAbstractPlantColumns.length
                            ? selectedAbstractPlantColumns
                            : (response.plant_columns || []);
                        exportColumns = [
                            { fieldName: 'delivery_challan_date', headerName: 'Date' },
                            ...cols.map((col) => ({ fieldName: col.field, headerName: col.label })),
                            { fieldName: 'total_qty', headerName: 'Total' },
                        ];
                        exportRecords = orderPlantwiseAbstractRows(
                            (response.dispatch_report_list || []).map((row) => (
                                mapPlantwiseAbstractRow(row, cols)
                            )),
                        );
                    } else {
                        let exportRows = sortDispatchRows(
                            (response.dispatch_report_list || []).map(mapDispatchReportRow),
                        );
                        if (formData.report_type === 'condensed') {
                            exportRows = sortDispatchRows(aggregateCondensedDispatchRows(exportRows));
                            exportRows = buildGroupedReportRows(exportRows, formData.report_format)
                                .filter((row) => !row.is_group_header);
                        } else {
                            exportRows = sortDispatchRows(exportRows).map((dc) => ({
                                plant_alias: dc.plant_alias,
                                salesrep_alias: dc.salesrep_alias,
                                delivery_challan_no: dc.delivery_challan_no,
                                delivery_challan_date: dc.delivery_challan_date,
                                delivery_challan_time: dc.delivery_challan_time,
                                customer_name: dc.customer_name,
                                project_name: dc.project_name,
                                dc_grade: dc.dc_grade,
                                dc_qty: dc.dc_qty,
                                rate: dc.rate,
                                amount: dc.amount,
                                delivery_mode: dc.delivery_mode,
                                vehicle_no: dc.vehicle_no,
                                pump: dc.pump,
                                gang: dc.gang,
                                total_km: dc.total_km,
                                invoice_number: dc.invoice_number,
                            }));
                        }
                        exportRecords = exportRows;
                        exportColumns = detailColumns;
                    }

                    exportAsExcel(exportColumns, exportRecords, 'dispatch_report');
                    setIsLoading(false);
                })
                .catch((error) => {
                    displayError(error.response?.data || getApiErrorMessage(error));
                    setIsLoading(false);
                });
            }
        };

    return (
            <div className="report-embedded-page">
                {!filtersVisible ? (
                    <div className="container-fluid px-3">
                        <ReportFilterToggleBar onShow={() => setFiltersVisible(true)} />
                    </div>
                ) : null}
                {filtersVisible ? (
                <form className="form" onSubmit={handleSubmit}>
                    <div className="container-fluid px-3">
                       <Row> 
                            <Col xl={12} lg={12} md={12}>
                                <div className="report-legacy-filters form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                        <div className="report-legacy-filters-fields">
                                        <ReactSelect
                                            options={customersWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            isClearable={true}
                                            value={selectedCustomer}
                                            onChange={onCustomerSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please select Customer"
                                            {...dispatchFilterSelectProps}
                                        />
                                        <ReactSelect
                                            options={sitesWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            isClearable={true}
                                            value={selectedSite}
                                            onChange={onSiteSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please Select Site"
                                            {...dispatchFilterSelectProps}
                                        />
                                        <ReactSelect
                                            options={gradesWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            isClearable={true}
                                            value={selectedGrade}
                                            onChange={onGradeSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please Select Grade"
                                            {...dispatchFilterSelectProps}
                                        />
                                        </div>
                                        <div className="report-legacy-filters-row">
                                        <RangePicker
                                            value={[fromDate, toDate]}
                                            format="DD-MM-YYYY"
                                            onChange={handleDateChange}
                                            style={{width:"270px"}}
                                        />
                                        <select
                                            className="browser-default custom-select col-sm-3"
                                            onChange={handleChange}
                                            value={inputs.report_format || (isSummaryReport ? 'plantwise' : 'datewise')}
                                            name="report_format"
                                            style={{width:"200px"}}
                                        >
                                            {isSummaryReport ? (
                                                <>
                                                    <option value="plantwise">Plantwise</option>
                                                    <option value="marketingwise">Marketingwise</option>
                                                    <option value="customerwise">Customerwise</option>
                                                    <option value="productwise">Productwise</option>
                                                </>
                                            ) : (
                                                <>
                                                    <option value="all">All</option>
                                                    <option value="datewise">Datewise</option>
                                                    <option value="customerwise">Customerwise</option>
                                                    <option value="marketingwise">Marketingwise</option>
                                                    <option value="plantwise_abstract">Plantwise - Abstract</option>
                                                </>
                                            )}
                                        </select>
                                        <div className="report-legacy-actions">
                                        <SettingsIcon onClickHandler={openReportSettings} variant="inline" />
                                        <ReportExportDropdown
                                            onExcel={handleDownloadExcel}
                                            onPDF={handleDownloadPdf}
                                            onImage={handleImageExport}
                                            disabled={isLoading}
                                        />
                                        <Button
                                            color="primary"
                                            className="list-page-toolbar-generate-btn"
                                            type="button"
                                            onClick={handleGenerate}
                                            disabled={isLoading}
                                        >
                                            Generate
                                        </Button>
                                        </div>
                                        </div>
                                </div>
                             </Col>
                        </Row>
                    </div> 
                </form>
                ) : null}
                <Modal isOpen={showSettingsModal} toggle={() => setShowSettingsModal(false)} centered>
                    <ModalHeader toggle={() => setShowSettingsModal(false)}>Report Settings</ModalHeader>
                    <ModalBody style={{ overflow: 'visible' }}>
                        <div className="mb-3" style={{ position: 'relative', zIndex: 5 }}>
                            <label className="font-weight-bold d-block mb-2">Plant</label>
                            <ReactSelect
                                options={plantsWithSelectAll}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isClearable={true}
                                value={settingsDraft.selectedPlant}
                                onChange={onSettingsPlantSelect}
                                className="react-select-dropdown"
                                placeholder="Please select Plant"
                                {...dispatchFilterSelectProps}
                            />
                        </div>
                        <div className="mb-3" style={{ position: 'relative', zIndex: 4 }}>
                            <label className="font-weight-bold d-block mb-2">Sales Rep</label>
                            <ReactSelect
                                options={salesrepsWithSelectAll}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isClearable={true}
                                value={settingsDraft.selectedSalesrep}
                                onChange={onSettingsSalesRepSelect}
                                className="react-select-dropdown"
                                placeholder="Please select Sales Rep"
                                {...dispatchFilterSelectProps}
                            />
                        </div>
                        <div className="mb-3" style={{ position: 'relative', zIndex: 3 }}>
                            <label className="font-weight-bold d-block mb-2">Vehicle</label>
                            <ReactSelect
                                options={vehiclesWithSelectAll}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isClearable={true}
                                value={settingsDraft.selectedVehicle}
                                onChange={onSettingsVehicleSelect}
                                className="react-select-dropdown"
                                placeholder={vehicles.length ? 'Please select Vehicle' : 'Loading vehicles...'}
                                noOptionsMessage={() => (vehicles.length ? 'No vehicles found' : 'Loading vehicles...')}
                                {...dispatchFilterSelectProps}
                            />
                        </div>
                        <div>
                            <label className="font-weight-bold d-block mb-2">Report Type</label>
                            <select
                                className="browser-default custom-select"
                                value={settingsDraft.report_type}
                                onChange={(event) => setSettingsDraft((current) => ({
                                    ...current,
                                    report_type: event.target.value,
                                }))}
                            >
                                <option value="detailed">Detailed</option>
                                <option value="condensed">Condensed</option>
                                <option value="all">All</option>
                                <option value="summary">Summary</option>
                            </select>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => setShowSettingsModal(false)}>Cancel</Button>
                        <Button color="primary" onClick={applyReportSettings}>Apply</Button>
                    </ModalFooter>
                </Modal>
                <div className="container-fluid px-3">
                        {(data.records.length > 0 || cancelledDetailRows.length > 0) ? (
                                <div className="list-page-summary-bar">
                                    <div className="list-page-summary-primary">
                                        <span className="list-page-summary-label">
                                            {showCancelledDetails
                                                ? 'CANCELLED DELIVERIES'
                                                : (isSummaryReport
                                                    ? `DISPATCH SUMMARY — ${String(summaryModeLabel || '').toUpperCase()}WISE`
                                                    : 'FILTERED VIEW')}
                                        </span>
                                        <span className="list-page-summary-count">
                                            {isSummaryReport && !showCancelledDetails
                                                ? `${fromDate.format('DD-MM-YYYY')} to ${toDate.format('DD-MM-YYYY')}`
                                                : (
                                                    <>
                                                        {(showCancelledDetails ? cancelledDetailRows : data.records).filter((row) => !row.is_group_header && !row.is_total).length}{' '}
                                                        {(showCancelledDetails ? cancelledDetailRows : data.records).filter((row) => !row.is_group_header && !row.is_total).length === 1 ? 'record' : 'records'}
                                                    </>
                                                )}
                                        </span>
                                        {isSummaryReport && !showCancelledDetails ? (
                                            <span className="list-page-summary-label" style={{ marginTop: 4 }}>
                                                {data.records.filter((row) => !row.is_group_header && !row.is_total).length}{' '}
                                                {data.records.filter((row) => !row.is_group_header && !row.is_total).length === 1 ? 'record' : 'records'}
                                            </span>
                                        ) : null}
                                    </div>
                                    <div className="list-page-summary-metrics">
                                        <div
                                            className="list-page-metric-card"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => setShowCancelledDetails(false)}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter' || event.key === ' ') {
                                                    event.preventDefault();
                                                    setShowCancelledDetails(false);
                                                }
                                            }}
                                            style={{ cursor: 'pointer', outline: showCancelledDetails ? undefined : '2px solid #ffd54f' }}
                                        >
                                            <span className="list-page-metric-label">Total DC Qty</span>
                                            <span className="list-page-metric-value is-yellow">{totalDcQty}</span>
                                        </div>
                                        <div
                                            className="list-page-metric-card is-cancelled-qty"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => {
                                                if (!cancelledDetailRows.length) {
                                                    return;
                                                }
                                                setShowCancelledDetails((open) => !open);
                                            }}
                                            onKeyDown={(event) => {
                                                if ((event.key === 'Enter' || event.key === ' ') && cancelledDetailRows.length) {
                                                    event.preventDefault();
                                                    setShowCancelledDetails((open) => !open);
                                                }
                                            }}
                                            style={{ cursor: cancelledDetailRows.length ? 'pointer' : 'default', outline: showCancelledDetails ? '2px solid #fecaca' : undefined }}
                                        >
                                            <span className="list-page-metric-label">Cancelled Qty</span>
                                            <span className="list-page-metric-value is-cancelled">{cancelledDcQty}</span>
                                        </div>
                                        {!isPlantwiseAbstract && !isSummaryReport ? (
                                        <>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Total Amount</span>
                                            <span className="list-page-metric-value">
                                                {showCancelledDetails
                                                    ? cancelledDetailRows.reduce((sum, row) => sum + Number(row.amount || 0), 0).toFixed(2)
                                                    : totalAmount}
                                            </span>
                                        </div>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Deliveries</span>
                                            <span className="list-page-metric-value is-b2b">
                                                {(showCancelledDetails ? cancelledDetailRows : data.records).filter((row) => !row.is_group_header).length}
                                            </span>
                                        </div>
                                        </>
                                        ) : (
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">{isSummaryReport ? summaryModeLabel : 'Days'}</span>
                                            <span className="list-page-metric-value is-b2b">
                                                {Math.max(data.records.filter((r) => !r.is_total).length, 0)}
                                            </span>
                                        </div>
                                        )}
                                    </div>
                                </div>
                        ) : null}
                        {isSummaryReport && summaryChartRows.length > 0 && !showCancelledDetails ? (
                            <DispatchSummaryChart
                                rows={summaryChartRows}
                                title={`Dispatch Summary — ${summaryModeLabel}wise Qty`}
                                period={`${fromDate.format('DD-MM-YYYY')} to ${toDate.format('DD-MM-YYYY')}`}
                                valueLabel="Qty"
                            />
                        ) : null}
                    <div className="list-page-table-wrap">
                        <div className="item-list-table-container">
                            <div className="table-responsive">
                                <ReactTableWrapper
                                    title={
                                        showCancelledDetails
                                            ? 'Dispatch Report - Cancelled'
                                            : (isSummaryReport
                                                ? `Dispatch Report - Summary (${summaryModeLabel}wise)`
                                                : (isPlantwiseAbstract ? 'Dispatch Report - Plantwise Abstract' : 'Dispatch Report'))
                                    }
                                    columns={columns}
                                    data={showCancelledDetails ? cancelledDetailRows : data.records}
                                    exportFilename="dispatch_report"
                                    enableTableSearch={false}
                                    enableExportToolbar={false}
                                    isLoading={isLoading}
                                    left_pinned={
                                        showCancelledDetails
                                            ? undefined
                                            : (isSummaryReport
                                                ? ['entity_name']
                                                : (isPlantwiseAbstract ? ['delivery_challan_date'] : undefined))
                                    }
                                    right_pinned={!showCancelledDetails && isPlantwiseAbstract ? [] : undefined}
                                    compactColumns={!showCancelledDetails && (isPlantwiseAbstract || isSummaryReport)}
                                    enableSorting={showCancelledDetails || (!isPlantwiseAbstract && !isSummaryReport)}
                                    centerHeaders
                                    normalBody
                                    getRowSx={(row) => {
                                        if (row.is_group_header || row.is_total) {
                                            return {
                                                backgroundColor: '#e8eef9 !important',
                                                '&:hover': { backgroundColor: '#d7e3f7 !important' },
                                                '& td': {
                                                    borderTop: '2px solid #1a3f8f',
                                                    borderBottom: row.is_total ? '2px solid #1a3f8f' : undefined,
                                                    fontWeight: 700,
                                                    color: '#0f255f',
                                                },
                                            };
                                        }
                                        return {};
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
);
}

export default DispatchReportTable;